import { Component, HostListener } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { MatDialogRef } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { addYears } from 'date-fns'
import { CreateWishlistCommand, CreateWishlistGQL } from '../../../../../graphql'
import { Amplitude } from '../../../../injectable'
import { generateId, UnsubscribeOnDestroy } from '../../../../utility'

@Component({
    selector: 'app-create-wishlist',
    templateUrl: 'create-wishlist.html'
})
export class CreateWishlistComponent extends UnsubscribeOnDestroy {
    nameControl: FormControl
    nextYear: number

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.code === 'Enter') {
            event.preventDefault()
        }
    }

    constructor(private _amplitude: Amplitude,
                private _dialogRef: MatDialogRef<CreateWishlistComponent>,
                private _createWishlistGQL: CreateWishlistGQL,
                private _snackBar: MatSnackBar) {
        super()

        this.nameControl = new FormControl('', Validators.required)
        this.nextYear = addYears(new Date(), 1).getFullYear()
    }

    createWishlist() {
        if (!this.nameControl.valid) { return }

        const command: CreateWishlistCommand = {
            wishlistId: generateId('wishlist'),
            name: this.nameControl.value,
        }

        this._subscriptions.push(this._createWishlistGQL.mutate({ input: command }).subscribe(result => {
            if (result?.errors?.length) {
                let message = 'There was an error creating your wishlist: ' + result.errors[0].message
                this._snackBar.open(message, 'Dismiss')
                throw new Error(message)
            }

            this._snackBar.open('Created successfully')
            this._amplitude.logEvent('Wishlist Created', {
                wishlistId: command.wishlistId,
            })

            this._dialogRef.close(result.data.createWishlist?.id)
        }))
    }
}
